import React from 'react';
import FilterItem from './components/FilterItem';
import ClearFilter from './components/ClearFilter';
import './style.scss';

interface FiltersProps {
  children?: React.ReactElement | React.ReactElement[];
}

const Filters = (props: FiltersProps): React.ReactElement => {
  return <div className="filters">{props.children}</div>;
};

Filters.Item = FilterItem;
Filters.Clear = ClearFilter;

export default Filters;
